import request from '@/utils/request'

export function pageSpaceDutyUser(query) {
  return request({
    url: '/system/spaceDutyUser/page',
    method: 'get',
    params: query,
  })
}

export function listSpaceDutyUser(query) {
  return request({
    url: '/system/spaceDutyUser/list',
    method: 'get',
    params: query,
  })
}

export function getSpaceDutyUser(data) {
  return request({
    url: '/system/spaceDutyUser/detail',
    method: 'get',
    params: data,
  })
}

export function addSpaceDutyUser(data) {
  return request({
    url: '/system/spaceDutyUser/add',
    method: 'post',
    data: data,
  })
}

export function updateSpaceDutyUser(data) {
  return request({
    url: '/system/spaceDutyUser/edit',
    method: 'post',
    data: data,
  })
}

export function delSpaceDutyUser(data) {
  return request({
    url: '/system/spaceDutyUser/delete',
    method: 'post',
    data: data,
  })
}
